<template>
  <div class="component-prizes-detail-info">
    <el-row class="row-info">
      <el-col :span="2" class="col-label">奖品名称</el-col>
      <el-col :span="22" class="col-value">{{ form.name }}</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">奖品类型</el-col>
      <el-col :span="22" class="col-value">{{ prizeTypeObjData[form.type] }}</el-col>
    </el-row>
    <el-row v-if="['Coupon', 'GiftCoupon', 'LotCoupon', 'SkuCoupon'].indexOf(form.type) >= 0" class="row-info" >
      <el-col :span="2" class="col-label">{{ prizeTypeObjData[form.type] }}</el-col>
      <el-col :span="22" class="col-value">
        <div class="coupon-table" style="margin-left: 0">
          <coupon-table :tableTrData="tableTrData" :couponType="form.type" ></coupon-table>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="form.type == 'MemberPoint'" class="row-info">
      <el-col :span="2" class="col-label">中奖积分</el-col>
      <el-col :span="22" class="col-value">{{ form.memberPointAmount }}</el-col>
    </el-row>
    <el-row v-if="form.type == 'Other'" class="row-info">
      <el-col :span="2" class="col-label">兑奖说明</el-col>
      <el-col :span="6" class="col-value">{{ form.description }}</el-col>
    </el-row>
    <el-row v-if="form.type === 'RedPackFixed'" class="row-info">
      <el-col :span="2" class="col-label">金额</el-col>
      <el-col :span="22" class="col-value">{{ form.redPackAmount }}</el-col>
    </el-row>
    <el-row v-if="form.type === 'RedPackRandom'" class="row-info">
      <el-col :span="2" class="col-label">优惠上限</el-col>
      <el-col :span="22" class="col-value">{{ form.redPackAmount }}</el-col>
    </el-row>
    <el-row v-if="form.type === 'RedPackRandom'" class="row-info">
      <el-col :span="2" class="col-label">红包比例</el-col>
      <el-col :span="22" class="col-value">{{ form.redPackOrderRatio }}%</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">奖品图片</el-col>
      <el-col :span="22" class="col-value">
        <el-image v-if="form.iconKey" :src="form.iconKey" class="img" fit="contain" />
      </el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">奖品总数量</el-col>
      <el-col :span="22" class="col-value">{{ form.amount }}</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">中奖概率</el-col>
      <el-col :span="22" class="col-value">{{ form.probability ? form.probability + "%" : "" }}</el-col>
    </el-row>
    <template>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">奖品每人可中</el-col>
        <el-col :span="22" class="col-value">{{ form.userTotalLimit }}次</el-col>
      </el-row>
      <el-row class="row-info" v-if="baseInfo.scene !== 'SupplierAfterPay'">
        <el-col :span="2" class="col-label">是否开启高级设置</el-col>
        <el-col :span="22" class="col-value">{{ form.advanceControl ? '是' : '否' }}</el-col>
      </el-row>
      <el-row class="row-info" v-if="form.advanceControl">
        <el-col :span="2" class="col-label">白名单会员</el-col>
        <el-col :span="22" class="col-value">
          <el-tooltip v-if="form.userWhitelist.length" placement="right" effect="light">
            <div class="user-box">{{form.userWhitePhone}}</div>
            <div slot="content">
              <div v-for="item in userWhitePhonelist" :key="item">{{item}}</div>
            </div>
          </el-tooltip>
          <span v-else>---</span>
        </el-col>
      </el-row>
      <el-row class="row-info" v-if="form.id && form.prizeMallDeployList.length">
        <el-col :span="2" class="col-label">投放商场</el-col>
        <el-col :span="22" class="col-value">
          <div class="table-box">
            <el-table
              :data="form.prizeMallDeployList"
              style="width: 100%"
              empty-text="暂无数据"
              :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
              :row-key="row => row.mallId"
              ref="table"
            >
              <el-table-column prop="mallName" label="商场名称" width="300"></el-table-column>
              <el-table-column prop="time" label="投放时间">
                <template slot-scope="scope" >
                  <div v-if="scope.row.deployTimeList && scope.row.deployTimeList.length">
                    <el-tooltip class="tooltip" placement="right" effect="light">
                      <div class="date-box">
                        <span>{{$moment(scope.row.deployTimeList[0].start).format('YYYY/MM/DD HH:mm:ss')}}</span>
                        <span>—</span>
                        <span>{{$moment(scope.row.deployTimeList[0].end).format('YYYY/MM/DD HH:mm:ss')}}</span>
                      </div>
                      <div slot="content">
                        <div v-for="(item, index) in scope.row.deployTimeList" :key="index">
                          <span>{{$moment(item.start).format('YYYY/MM/DD HH:mm:ss')}}</span>
                          <span>—</span>
                          <span>{{$moment(item.end).format('YYYY/MM/DD HH:mm:ss')}}</span>
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  <span v-else>---</span>
                </template>
              </el-table-column>
              <el-table-column prop="deployLimit" label="投放数量"></el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            />
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import couponTable from '../../components/couponTable.vue'

export default {
  name: "componentPrizesDetailInfo",
  components: {
    couponTable,
  },
  props: {
    prizeTypeObjData: {
      type: Object,
      default() {
        return {}
      }
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    tableTrData: {
      type: Array,
      default() {
        return []
      }
    },
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      userWhitePhonelist: [],
      prizeMallDeployList: [],
      total: 0,
      offset: 0,
      limit: 10,
    };
  },
  created() {
    this.userWhitePhonelist = this.form.userWhitePhone.split('，')
    this.total = this.form.prizeMallDeployList.length
    this.getMallList() // 获取商场列表数据
  },
  methods: {
    // 获取商场列表数据
    getMallList() {
      this.prizeMallDeployList = [...this.form.prizeMallDeployList].splice(this.offset, this.limit)
    },

    handleSizeChange (limit) {
      this.limit = limit
      this.getMallList()
    },

    handleCurrentChange (val) {
      this.offset = (val - 1) * this.limit
      this.getMallList()
    },
  },
};
</script>

<style lang="scss" scoped>
.component-prizes-detail-info {
  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;

      .img {
        border: 1px solid #eee;
        border-radius: 2px;
        width: 150px;
        height: 150px;
      }
    }
  }

  .user-box {
    display: inline-block;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .coupon-table {
    width: 80%;
    margin-left: 100px;
    margin-bottom: 20px;
  }

  .table-box {
    border: 1px solid #ccc;
    padding: 5px;
    padding-bottom: 0;
    border-radius: 4px;
    overflow: hidden;

    .date-box {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-pagination {
      margin: 20px 0;
    }
  }
}
</style>
